var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"create-template"}},[_c('create-template-form',{attrs:{"template":undefined,"submit":_vm.createTemplate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }